import api from './api';

// Base endpoint for profile operations
const BASE_URL = '/profile';

/**
 * Fetches the currently logged-in user's profile information.
 */
export const getProfile = async () => {
    try {
        const response = await api.get(`${BASE_URL}/me`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * Updates the user's personal profile details.
 */
export const updateProfile = async (profileData) => {
    try {
        const response = await api.put(`${BASE_URL}/me`, profileData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * Changes the user's password.
 */
export const changePassword = async (passwordData) => {
    try {
        const response = await api.put(`${BASE_URL}/change-password`, passwordData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

/**
 * Removes the user's profile picture by setting the URL to null.
 */
export const removeProfilePicture = async () => {
    try {
        // Send an update request with a null URL to clear the picture
        const response = await api.put(`${BASE_URL}/me`, { profile_picture_url: null });
        // console.log('Remove Profile Picture Response:', response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
};